
export enum WhatIfShipmentSelectionTypeCd {
	ACCOUNT = 'Account',
	AGREEMENT_ID = 'AgreementId',
	CUSTOMER_SHIPMENT = 'CustomerShipment',
	XPO_SHIPMENT = 'XpoShipment'}
